import ScrollLink, { SCROLL_DURATION } from './link';
import ScrollElement from './element';

export { ScrollLink, ScrollElement, SCROLL_DURATION };
